import { assert_true } from '@shared/asserts/utils_asserts';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { G_UI_FIELD__header } from './G_UI_FIELD__header';

interface PROPS {
  field: FIELD__base;
}

export function G_UI_FIELD__output({ field }: PROPS) {
  assert_true(field.meta.kind__is_output);
  /*
   * STORE
   */

  /*
   * STATE
   */

  /*
   * HTML
   */

  return (
    <div className="flex flex-col">
      {/* HEADER */}
      <G_UI_FIELD__header {...{ field }} />
      <div className={`p-1 text-xs text-bar-foreground text-left break-words bg-component `}>Computed</div>
    </div>
  );
}
